import React from 'react';

import CreativeAttributes from 'scenes/Gallery/GalleryPage/Creatives/components/CreativeAttributes';
import { DetailsFile, PreviewNewFile } from 'scenes/Gallery/components/File';
import {
  EXTENSION,
  HEIGHT,
  ORIENTATION,
  ROOT_HTML_URL,
  SIZE,
  URL,
  VIDEO_LENGTH,
  WIDTH,
  RATIO,
} from 'scenes/Gallery/components/File/constants';

const CreativePreview = ({
  creativeType,
  fileInfo,
  variant = 'outlined',
  width,
  height,
  maxWidth,
  maxHeight,
}) => {
  const {
    uploadType,
    fileOverSize,
    progress,
    [URL]: fileUrl,
    [ROOT_HTML_URL]: fileRootHtmlUrl,
    [EXTENSION]: fileExtension,
    [WIDTH]: fileWidth,
    [HEIGHT]: fileHeight,
    [VIDEO_LENGTH]: fileVideoLength,
    [SIZE]: fileSize,
    [ORIENTATION]: fileOrientation,
    [RATIO]: fileRatio,
  } = fileInfo || {};

  const creativePreviewAttributes = (
    <CreativeAttributes
      creativeType={creativeType}
      fileExtension={fileExtension}
      fileVideoLength={fileVideoLength}
      fileWidth={fileWidth}
      fileHeight={fileHeight}
      fileSize={fileSize}
      fileOrientation={fileOrientation}
      fileRatio={fileRatio}
      flexWrap={'wrap'}
    />
  );

  if (uploadType) {
    return (
      <PreviewNewFile
        type={uploadType}
        progress={progress}
        fileOverSize={fileOverSize}
        src={fileUrl}
        width={width || fileWidth}
        height={height || fileHeight}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        attributes={creativePreviewAttributes}
        variant={variant}
      />
    );
  }

  return (
    <DetailsFile
      src={fileRootHtmlUrl || fileUrl}
      width={width || fileWidth}
      height={height || fileHeight}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      creativeTypeId={creativeType}
      attributes={creativePreviewAttributes}
      variant={variant}
    />
  );
};

export default CreativePreview;
